import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Label,
  Input,
  ModalFooter
} from 'reactstrap';
import CheckBox from '@componentes/checkbox/checkbox.component';
import * as commonActions from '@common/common.action';
import WebapiCommon from '@util/webapi.common';
import { injectIntl } from 'react-intl';

function CheckCritico ({intl}) {
  const dispatch = useDispatch();
  const detalhes = useSelector(state => state.commonReducer.detalhes);
  const listagemState = useSelector(state => state.commonReducer.listagem);
  const [modalCritico, setModalCritico] = useState(false);
  const [justificativa, setJustificativa] = useState('');
  const { messages } = intl;

  const marcarCritico = () => {
    var critico = detalhes.critico ? false : true;
    dispatch(commonActions.showFadeCarregando(true));
    WebapiCommon.marcarLaudoCritico(
      detalhes.laudo,
      critico,
      justificativa
    ).then(() => {
      var detalhesUpdated = detalhes;
      detalhesUpdated.critico = critico;
      dispatch(commonActions.atualizarDetalhes(detalhesUpdated));
      setJustificativa('');
      setModalCritico(false);

      let listagem = [...listagemState];
      const listagemIndex = listagem.findIndex(
        item => item.laudo === detalhesUpdated.laudo
      );
      listagem[listagemIndex] = detalhesUpdated;
      dispatch(commonActions.preencherListagem(listagem));
      dispatch(commonActions.showFadeCarregando(false));
      dispatch(
        commonActions.showAlerta(
          'sucesso',
          'Operação realizada com sucesso.',
          1500
        )
      );
    });
  };

  const toggle = () => setModalCritico(!modalCritico);

  const onClickCheck = () => {
    if (detalhes.entregue) {
      dispatch(
        commonActions.showAlerta(
          'alerta',
          'Ação cancelada pois o exame já foi entregue.',
          3000,
          '500px'
        )
      );
      return;
    }
    setModalCritico(true);
  };

  return (
    <div>
      <div onClick={onClickCheck}>
        <CheckBox readOnly label={messages['dashboards.examDetails.criticalReport']} checked={detalhes.critico} />
      </div>

      <Modal isOpen={modalCritico} toggle={toggle}>
        <ModalHeader toggle={toggle}>
         {messages['dashboards.examDetails.changeInCriticality']}
        </ModalHeader>
        <ModalBody>
          <Label>{messages['dashboards.examDetails.justification']}</Label>
          <Input
            type='text'
            style={{ fontSize: '15px' }}
            onChange={e => setJustificativa(e.currentTarget.value)}
            value={justificativa}
            maxLength={250}
          />
        </ModalBody>
        <ModalFooter>
          <Button color='secondary' onClick={toggle}>
          {messages['dashboards.examDetails.cancel']}
          </Button>
          <Button
            color='primary'
            onClick={marcarCritico}
            disabled={!justificativa || justificativa === ''}
          >
            {messages['dashboards.examDetails.confirm']}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default injectIntl (CheckCritico);



// WEBPACK FOOTER //
// ./src/pages/laudo/detalhesExame/CheckCritico/index.js